import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';
import './LeadershipPage.css';

const members = [
  {
    name: 'Rejani Shibu',
    role: 'President',
    image: '/Sndp/president.jpg',
  },
  {
    name: 'Shyamala Satheeshan',
    role: 'Vice President',
    image: '/Sndp/vp.jpg',
  },
  {
    name: 'Sudhakaran Sreedharan',
    role: 'General Secretary',
    image: '/Sndp/gs.jpg',
  },
  {
    name: 'Lanin Kumar',
    role: 'Organisational Secretary',
    image: '/Sndp/os.jpg',
  },
];

const membersRow2 = [
  {
    name: 'Vishnu Babu',
    role: 'HR Secretary',
    image: '/Sndp/hrs.jpg',
  },
  {
    name: 'Jayaprakash',
    role: 'Cultural Secretary',
    image: '/Sndp/cu.jpg',
  },
  {
    name: 'Sunil KS',
    role: 'Devasam Secretary',
    image: '/Sndp/devas.jpg',
  },
];

const LeadershipPage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  return (
    <div className="lp-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Hero — Sree Narayana Guru card */}
      <div className="lp-hero-wrapper">
        <div className="lp-hero-card">
          <div className="lp-hero-img">
            <img src="/Sndp/567575675756-1280x720.jpg" alt="Sree Narayana Guru" />
          </div>
          <div className="lp-hero-content">
            <div className="lp-hero-meta">
              <div className="lp-hero-badge">
                <span className="lp-hero-badge-dot"></span>
                <span className="lp-hero-badge-text">1854 – 1928</span>
              </div>
              <h1 className="lp-hero-name">SREE NARAYANA GURU</h1>
              <p className="lp-hero-role">Spiritual Leader &amp; Social Reformer</p>
              <div className="lp-hero-divider"></div>
            </div>
            <p className="lp-hero-desc">
              Sree Narayana Gurudev was a Great Saint, Social Reformer, Philosopher and
              Revolutionary humanist and his life and teachings have transgressed the
              boundaries of not only India but also the world. His teachings and preachings
              have great contemporary relevance in the context of our efforts to promote
              social justice.
            </p>
            <div className="lp-hero-quote">
              <p>"One Caste, One Religion, One God for Man"</p>
            </div>
          </div>
        </div>
      </div>

      {/* Executive Members heading */}
      <div className="lp-section-heading">
        <h2>Our Executive Members</h2>
        <div className="lp-section-heading-bar"></div>
      </div>

      {/* Member cards */}
      <div className="lp-members-section">
        {/* Row 1: 4 members */}
        <div className="lp-members-row">
          {members.map((m) => (
            <div
              key={m.name}
              className="lp-member-card"
              style={{ backgroundImage: `url('${m.image}')`, backgroundSize: 'cover', backgroundPosition: 'center' }}
            >
              <div className="lp-member-card-overlay"></div>
              <div className="lp-member-card-info">
                <p className="lp-member-name">{m.name}</p>
                <p className="lp-member-role">{m.role}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Row 2: 3 members */}
        <div className="lp-members-row">
          {membersRow2.map((m) => (
            <div
              key={m.name}
              className="lp-member-card"
              style={{ backgroundImage: `url('${m.image}')`, backgroundSize: 'cover', backgroundPosition: 'center' }}
            >
              <div className="lp-member-card-overlay"></div>
              <div className="lp-member-card-info">
                <p className="lp-member-name">{m.name}</p>
                <p className="lp-member-role">{m.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LeadershipPage;
